export default "__VITE_ASSET__D7Q0Pebn__"